<template>
    <f7-page name="meteo-vystrahy-detail" @page:init="onPageInit">
        <f7-navbar>
            <f7-nav-left>
                <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
            </f7-nav-left>
            <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
            <f7-nav-right>
                <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
                <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
            </f7-nav-right>
        </f7-navbar>

        <f7-block v-if="selectedRegion !== null" class="no-margin no-padding">
            <template v-if="!notEmptyObject(warningData)">
                <f7-block strong class="text-align-center no-margin-top bg-color-green">
                    Pre vybraný okres nie sú vydané žiadne meteorologické výstrahy
                </f7-block>
            </template>
            <template v-else>
                <f7-block strong class="no-margin">
                    Okres: <strong>{{ warningData.region_popis }}</strong>
                </f7-block>
                <f7-card v-for="(vystraha, index) in warningData.vystrahy" :key="index">
                    <f7-card-header :class="'vystraha-' + vystraha.stupen + ' display-block vystraha-header'">
                        <div class="float-left vystraha-header-icon">
                            <img :src="'static/shmu/img/meteovystrahy/'+ vystraha.jav.jav_key.toLowerCase() + '.svg'" width="40">
                        </div>
                        <div class="float-left vystraha-header-jav">
                            <span class="font-weight-bold">{{ vystraha.jav.jav_popis }}</span>
                        </div>
                        <div class="float-right vystraha-header-stupen">
                            <strong>{{ vystraha.stupen}}. stupeň</strong>
                        </div>
                    </f7-card-header>
                    <f7-card-content>
                        <div class="vystraha-ctnt">
                            <div class="row">
                                <div class="col fs-075 margin-bottom-half">
                                    <i class="f7-icons font-size-17">clock</i> od <strong>{{ vystraha.javod*1000 | moment('DD.MM.YYYY HH:mm') }}</strong>
                                    do <strong>{{ (vystraha.javdo+1)*1000 | moment('DD.MM.YYYY HH:mm') }}</strong>

                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    {{ vystraha.vtext }}
                                </div>
                            </div>
                        </div>
                        <div class="vystraha-subctnt" v-if="vystraha.vietor">Vietor: <strong>{{ vystraha.vietor }}</strong></div>
                        <div class="vystraha-subctnt" v-if="vystraha.zrazky">Zrážky: <strong>{{ vystraha.zrazky }}</strong></div>
                        <div class="vystraha-subctnt" v-if="vystraha.sneh">Sneh: <strong>{{ vystraha.sneh }}</strong></div>
                        <div class="vystraha-subctnt" v-if="vystraha.dohladnost">Dohľadnosť: <strong>{{ vystraha.dohladnost }}</strong></div>
                        <div class="vystraha-subctnt" v-if="vystraha.teplota">Teplota: <strong>{{ vystraha.teplota }}</strong></div>
                    </f7-card-content>
                </f7-card>
            </template>

        </f7-block>

    </f7-page>
</template>
<script>
    import Axios from "axios";
    import SHMUconf from "../js/SHMUconf";
    import { latLng } from "leaflet";
    import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson, LControlZoom } from 'vue2-leaflet';
    import 'leaflet/dist/leaflet.css';
    import geoJsonMeteoMap from '../static/shmu/maps/meteo_map';


    export default {

        data: function () {
            return {
                pageTitle: 'Meteo výstrahy',
                warningData: {},
                selectedRegion: null,
                isDataLoaded: false,
                lastUpdated: 0,
                tCheckInterval: null,
            };
        },
        filters: {
            capitalize: function(s) {
                return s.charAt(0).toUpperCase() + s.slice(1)
            }
        },
        watch: {
            latestData: function() {
                if (this.latestData.length > 0) {
                    this.isWarnings = true;
                } else {
                    this.isWarnings = false;
                }
            },
        },
        mounted() {
            const self = this;
            // otvorime hlavne menu
            this.$f7.accordion.close('.shmu-i-pocasie');
            this.$f7.accordion.open('.shmu-i-pocasie');

        },
        destroy() {
            clearInterval(this.tCheckInterval);
        },
        methods: {
            onPageInit() {
                this.selectedRegion = this.$f7route.params.region;
                this.pageReload(null, true);
            },
            pageReload(event, isInit) {
                const self = this;

                if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh
                    self.loadWarningsData();
                }


            },
            loadWarningsData() {
                const self = this;

                if (this.selectedRegion) {

                    self.$f7.dialog.preloader('Načítavam...');
                    Axios.get(SHMUconf.API_BASE_URL + 'meteo/getwarnings?region=' + this.selectedRegion, {
                        crossDomain: true,
                        cache: false,
                    })
                        .then((response) => {
                            if (!response.data.error) {
                                self.warningData = response.data;
                                self.isDataLoaded = true;
                                self.lastUpdated = self.$moment().unix();
                                // clearInterval(this.tCheckInterval);
                                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60 * 1000); // overujem kazdu minutu

                            } else {
                                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne meteorologické výstrahy', 'Nastala chyba');
                            }
                            self.$f7.dialog.close();
                        }).catch((error) => {
                        self.$f7.dialog.close();
                        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
                    });
                }


            },
            checkLastUpdated() {
                if ((this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
                    this.pageReload(null, false);
                }
            }

        }

    };
</script>

<style lang="scss">

    .vystraha-ctnt {
        margin-bottom: 0.2rem;
    }
    .vystraha-subctnt {
        border-top: 1px solid var(--f7-list-border-color);
        padding: 0.4rem 0;
    }

    .vystraha-header-icon {
        line-height: 11px;
        padding-top:0px;
    }
    .vystraha-header-jav {
        line-height: 40px;
        margin-left:0.5rem;
    }

    .vystraha-header-stupen {
        line-height: 40px;
    }

    .ios {
        .vystraha-header {
            padding: 0.15rem 0.8rem;
        }
    }

</style>
